module.exports = __webpack_public_path__ + "img/undraw_directions_x53j.8d1693a1.svg";